import React from "react";
import Header from "@/components/shared/Header";
import { useLocation, useNavigate } from "react-router-dom";
import Details from "@/components/history/Details";
import Timelines from "@/components/history/Timelines";
import TraceabilityHistory from "@/components/history/TraceabilityHistory";

export default function HistoryDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <div className="flex flex-column lg:flex-row">
      <div className="w-full lg:w-7 lg:min-h-screen lg:border-right-1 border-gray-400">
        <Header title="History Details" onBack={() => navigate(-1)} />
        <Details item={state} />
        <TraceabilityHistory item={state} />
      </div>

      <div className="w-full lg:w-5">
        <Header title="Timelines" />
        <Timelines item={state} />
      </div>
    </div>
  );
}
